/* eslint-disable no-async-promise-executor */
import { SystemContext } from 'contexts/legacy/SystemContext';
import React from 'react';
import { api, billing } from 'services/api';

class SystemProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: '',
      promotionalModal: false,
      informationModal: true,
      dashboard: {
        actual_month: {
          in: [],
          out: [],
        },
        last_month: {
          in: [],
          out: [],
        },
        actual_month_fields: {
          in: [],
          out: [],
        },
        last_month_fields: {
          in: [],
          out: [],
        },
        quantidade: {},
        old_quantidade: {},
      },
      dashboard_indicator: {
        in: {
          qtd: 0,
        },
        out: {
          qtd: 0,
        },
      },
      products: [],
      monthly_messages: 20000,
      message_count_total: 0,
      message_count_in: 0,
      message_count_out: 0,
      subscription: {
        days_left: 0,
        items: [{ product_id: -1 }],
        status: 'not-found',
      },
      trial: true,
      system_version: 0,
      infos: {
        domain: '',
        auth: '',
        access_token: '',
      },
      subscriptionReady: false,
      subscriptionError: false,
      gotostep: false,
      lastVersion: '',
      loadingUpdates: true,
      loadingDashboard: true,
      loadingSubscription: true,
      loadingConfirmSteps: false,
      loadingMessageCount: true,
      updates: [],
      updatesList: [],
      expired: true,

      // variaveis dos relatorios
      leads_criados: 0,
      leads_convertidos: 0,
      leads_perdidos: 0,
      deals_ganhos: 0,
      deals_perdidos: 0,
      deals_em_andamento: 0,
      deals_one_months: 0,
      deals_two_months: 0,
      deals_three_months: 0,
      deals_four_months: 0,
      deals_five_months: 0,
      deals_six_months: 0,
      opportunity: 0,
      percent_leads: 0,
      percent_deals: 0,
      periodo_inicio: 0,
      periodo_fim: 0,
      loadingGraph: true,
      loadingDate: true,

      getListOfUpdates: this.getListOfUpdates.bind(this),
      getDashboard: this.getDashboard.bind(this),
      addSubscription: this.addSubscription.bind(this),
      setTour: this.setTour.bind(this),
      setCloseAlert: this.setCloseAlert.bind(this),
      getSubscriptions: this.getSubscriptions.bind(this),
      hidePromitionalModal: this.hidePromitionalModal.bind(this),
      getMessageCount: this.getMessageCount.bind(this),
      hideInformationModal: this.hideInformationModal.bind(this),
      setData: this.setData.bind(this),
    };
  }

  async getMessageCount() {
    this.setState({ loadingMessageCount: true });
    const request = {
      action: 'getMessageCount',
      domain: this.state.infos.domain,
      auth: this.state.infos.auth,
    };

    await api.post('getMessageCount', request).then((res) => {
      this.setState({ loadingMessageCount: false });
      if (res.data.status) {
        this.setState({ message_count_total: res.data.dados.total });
        this.setState({ message_count_in: res.data.dados.in });
        this.setState({ message_count_out: res.data.dados.out });
      }
    });
  }

  async setData(dataString) {
    this.setState({ loadingDate: true });
    this.setState({ loadingGraph: true });

    const data = {
      action: 'setData',
      domain: this.state.infos.domain,
      auth: this.state.infos.auth,
      dataString,
    };

    await api.post('setData', data).then(async (res) => {
      this.setState({
        loadingDate: false,
        loadingGraph: false,
      });

      if (res.data.status) {
        this.setState({
          leads_criados: res.data.dados.leads_criados,
          leads_convertidos: res.data.dados.leads_convertidos,
          leads_perdidos: res.data.dados.leads_perdidos,
          opportunity: res.data.dados.opportunity,
          percent_leads: res.data.dados.percent_leads,
          percent_deals: res.data.dados.percent_deals,
          deals_ganhos: res.data.dados.deals_ganhos,
          deals_perdidos: res.data.dados.deals_perdidos,
          deals_em_andamento: res.data.dados.deals_em_andamento,
          deals_one_months: res.data.dados.deals_one_months,
          deals_two_months: res.data.dados.deals_two_months,
          deals_three_months: res.data.dados.deals_three_months,
          deals_four_months: res.data.dados.deals_four_months,
          deals_five_months: res.data.dados.deals_five_months,
          deals_six_months: res.data.dados.deals_six_months,
          periodo_inicio: res.data.dados.periodo_inicio,
          periodo_fim: res.data.dados.periodo_fim,
        });
      }
    });
  }

  async componentDidMount() {
    window.BX24.init(async () => {
      const auth = window.BX24 ? window.BX24.getAuth() : { domain: 'solinka.bitrix24.com' };

      this.setState({ access_token: auth.access_token });

      const { domain } = auth;

      await this.loadClientInfos(domain)
        .then(async () => {
          this.setState({ loadingDate: false });
          if (!this.props.step) {
            await this.getListOfUpdates();
            await this.getDashboard();
            await this.getProducts();
            await this.getMessageCount();
            await this.getSubscriptions();
          }
        })
        .catch((e) => {
          console.log('SystemProvider::componentDidMount - loadClientInfos', {
            Exception: e,
          });
        });
    });
  }

  hidePromitionalModal() {
    this.setState({ promotionalModal: false });
  }

  hideInformationModal() {
    this.setState({ informationModal: false });
  }

  loadClientInfos(domain) {
    return new Promise(async (resolve, reject) => {
      this.setState({ loadingClient: true });
      const request = {
        action: 'getClient',
        domain,
      };

      await api.post('getClient', request).then(async (res) => {
        this.setState({ loadingClient: false });
        if (res.data.status) {
          this.setState({
            infos: res.data.dados,
            gotostep: res.data.dados.tour === 0,
          });
          resolve(res.data);
        } else {
          reject(res.data);
        }
      });
    });
  }

  async setTour() {
    return new Promise(async (resolve, reject) => {
      this.setState({ loadingConfirmSteps: true });
      const request = {
        action: 'setTour',
        domain: this.state.infos.domain,
        auth: this.state.infos.auth,
      };

      await api.post('setTour', request).then((res) => {
        this.setState({ loadingConfirmSteps: false });
        if (res.data.status) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      });
    });
  }

  async setCloseAlert(user) {
    return new Promise(async (resolve, reject) => {
      const request = {
        action: 'setCloseAlert',
        domain: this.state.infos.domain,
        auth: this.state.infos.auth,
        userId: user.ID,
        userName: user.NAME,
      };

      await api.post('setCloseAlert', request).then((res) => {
        if (res.data.status) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      });
    });
  }

  executeMethodOnBitrix(method, data) {
    return new Promise(async (resolve) => {
      await window.BX24.callMethod(method, data, (result) => {
        resolve(result);
      });
    });
  }

  async addSubscription() {
    return new Promise(async (resolve, reject) => {
      this.setState({ loadingConfirmSteps: true });
      const request = {
        action: 'addSubscription',
        domain: this.state.infos.domain,
        auth: this.state.infos.auth,
      };

      await api.post('addSubscription', request).then((res) => {
        this.setState({ loadingConfirmSteps: false });
        if (res.data.status) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      });
    });
  }

  async getListOfUpdates() {
    this.setState({ loadingUpdates: true });
    const request = {
      domain: this.state.infos.domain,
      auth: this.state.infos.auth,
    };

    await api.get('changelog/getPublishedVersions', request).then((res) => {
      this.setState({ loadingUpdates: false });
      if (res.data) {
        this.setState({ updates: res.data });
        this.setState({
          system_version: res.data[0].version,
        });
      }
    });
  }

  async getProducts() {
    this.setState({ loadingProducts: true });
    const request = {
      action: 'getProducts',
      domain: this.state.infos.domain,
      auth: this.state.infos.auth,
    };

    await api.post('getProducts', request).then((res) => {
      this.setState({ loadingProducts: false });
      if (res.data.status) {
        this.setState({ products: res.data.dados.list });
      }
    });
  }

  async fetchSubscription() {
    return new Promise(async (resolve) => {
      this.setState({ loadingSubscription: true, subscriptionError: false });
      const data = {
        action: 'getSubscription',
        domain: this.state.infos.domain,
        auth: this.state.infos.auth,
      };

      try {
        const res = await billing.get(`stripe/subscriptions/legacy/${data.domain}`, {
          headers: {
            Authorization: this.state.infos.access_token,
          },
        });

        this.setState({ loadingSubscription: false });
        resolve(res);
      } catch (err) {
        try {
          const res = await api.post('getSubscription', data);

          this.setState({ loadingSubscription: false });
          resolve(res);
        } catch (fallbackErr) {
          console.log('SystemProvider::fetchSubscription - falha ao consultar a assinatura', {
            Exception: fallbackErr,
          });

          this.setState({ loadingSubscription: false, subscriptionError: true });
          resolve(null);
        }
      }
    });
  }

  async getSubscriptions() {
    return new Promise(async (resolve, reject) => {
      const res = await this.fetchSubscription();
      const dados = res?.data?.dados;

      if (!dados) {
        this.setState({ subscriptionError: true });
        reject(res?.data ?? null);
        return;
      }

      if (res.data.dados.status) {
        if (res.data.dados.items[0].monthly_messages) {
          this.setState({
            monthly_messages: res.data.dados.items[0].monthly_messages,
          });
        }

        this.setState({ subscription: res.data.dados });
        this.setState({
          expired: !(res.data.dados.length === 0 || res.data.dados.status === 'active'),
        });
        this.setState({
          trial: !!(res.data.dados.type && res.data.dados.type === 'trial'),
        });
        this.setState({ subscriptionReady: true, promotionalModal: true });
        resolve(res.data);
      } else {
        reject(res.data);
      }
    });
  }

  async getDashboard(number = null, data = null) {
    this.setState({ loadingDashboard: true });
    const request = {
      action: 'getDashboard',
      domain: this.state.infos.domain,
      auth: this.state.infos.auth,
      filter: {
        number,
        data,
      },
    };

    await api.post('getDashboard', request).then((res) => {
      this.setState({ loadingDashboard: false });
      if (res.data.status) {
        const newData = {
          dashboard: {
            quantidade: res.data.dados.qtds,
            old_quantidade: res.data.dados.old_qtds,
            actual_month_fields: res.data.dados.actual_month_fields,
            last_month_fields: res.data.dados.last_month_fields,
            actual_month: res.data.dados.actual_month_data,
            last_month: res.data.dados.last_month_data,
          },
        };

        this.setState(newData);
        this.setState({ dashboard_indicator: res.data.dados.section });
      }
    });
  }

  render() {
    return <SystemContext.Provider value={this.state}>{this.props.children}</SystemContext.Provider>;
  }
}

export default SystemProvider;
